"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NavItemContentATag = void 0;
var _react = _interopRequireWildcard(require("react"));
var _uiKit = require("@icis/ui-kit");
var _l10n = require("../../../../../../l10n");
var _Text = _interopRequireDefault(require("../../../../../Text/Text.render"));
var _ActivityFeedContext = require("../../Functionality/ActivityFeed/ActivityFeedContext");
var _NavItem = require("../../NavItem.style");
var _NewForUser = _interopRequireDefault(require("../NewForUser"));
var _AskICIS = _interopRequireDefault(require("../../../../../AskICIS"));
const NavItemContentATag = exports.NavItemContentATag = _NavItem.NavItemContent.withComponent('a');
const LabelRender = _ref => {
  let {
    locale,
    selected,
    hasSubMenu,
    id,
    showAsButton,
    newIcon,
    text
  } = _ref;
  const {
    hasEverClickedAlertsFeed
  } = (0, _react.useContext)(_ActivityFeedContext.AlertsFeedContext);
  const navItemProps = {};
  let NavItemWrapper = _NavItem.NavItemContent;
  if (hasSubMenu) {
    NavItemWrapper = NavItemContentATag;
    navItemProps['aria-expanded'] = selected ? 'true' : 'false';
    navItemProps['aria-haspopup'] = 'true';
    navItemProps['aria-controls'] = "subMenu-".concat(id);
    if (!text && newIcon) {
      navItemProps['aria-label'] = (0, _l10n.getMessages)(locale)("NavIconAccessibilityText.".concat(newIcon));
    }
  }
  const showAnimation = (newIcon === null || newIcon === void 0 ? void 0 : newIcon.toLowerCase()) === 'alerts' && !hasEverClickedAlertsFeed;
  return /*#__PURE__*/_react.default.createElement(_NavItem.NavItemInner, {
    showAsButton: showAsButton,
    hovering: selected
  }, /*#__PURE__*/_react.default.createElement(NavItemWrapper, Object.assign({}, navItemProps, {
    "data-testid": "sh-label-nav-item"
  }), newIcon && !showAsButton && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, showAnimation && /*#__PURE__*/_react.default.createElement(_NewForUser.default, null), newIcon.includes('askicis') ? /*#__PURE__*/_react.default.createElement(_AskICIS.default, {
    isBeta: newIcon.includes('beta')
  }) : /*#__PURE__*/_react.default.createElement(_NavItem.IconAnimationContainer, {
    shouldAnimate: showAnimation
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
    icon: newIcon,
    size: "1x",
    color: selected ? _uiKit.theme.colours.PRIMARY_1 : _uiKit.theme.colours.WHITE
  }))), text && !newIcon && !showAsButton && /*#__PURE__*/_react.default.createElement(_NavItem.NavItemContainerWithChevron, {
    selected: selected
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    type: "ButtonText",
    selected: selected,
    intlText: text,
    variant: selected ? 'Tertiary' : 'Primary'
  }), hasSubMenu && /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
    icon: "chevron-regular-down",
    size: "1x",
    color: selected ? _uiKit.theme.colours.PRIMARY_1 : _uiKit.theme.colours.WHITE
  })), text && showAsButton && /*#__PURE__*/_react.default.createElement(_Text.default, {
    type: "ButtonText",
    variant: "Secondary",
    selected: selected,
    intlText: text
  })));
};
var _default = exports.default = LabelRender;